import type { Routes } from '@angular/router';
import { secureRoute } from './core/utils/transformers';
import { ServiceProviderCreateComponent } from './features/service-providers/pages/service-provider-create/service-provider-create';
import { ServiceProviderDetailsComponent } from './features/service-providers/pages/service-provider-details/service-provider-details';
import { ServiceProviderEditComponent } from './features/service-providers/pages/service-provider-edit/service-provider-edit';
import { ServiceProvidersViewComponent } from './features/service-providers/pages/service-providers-view/service-providers-view';

export const serviceProviderRoutes: Routes = [
  secureRoute({
    path: 'service-providers',
    component: ServiceProvidersViewComponent,

    data: {
      roles: ['mhs.scmmanager.user'],
      breadcrumbs: [
        {
          id: 0,
          label: 'podmioty',
          isCurrent: true,
          url: '/service-providers',
        },
      ],
    },
  }),
  secureRoute({
    path: 'service-providers/:id/details',
    component: ServiceProviderDetailsComponent,

    data: {
      roles: ['mhs.scmmanager.user'],
      breadcrumbs: [
        {
          id: 0,
          label: 'podmioty',
          isCurrent: false,
          url: '/service-providers',
        },
        {
          id: 1,
          label: 'detale',
          isCurrent: true,
          url: '/service-providers/:id/details',
        },
      ],
    },
  }),
  secureRoute({
    path: 'service-providers/create',
    component: ServiceProviderCreateComponent,

    data: {
      roles: ['mhs.scmmanager.user'],
      breadcrumbs: [
        {
          id: 0,
          label: 'podmioty',
          isCurrent: false,
          url: '/service-providers',
        },
        {
          id: 1,
          label: 'tworzenie',
          isCurrent: true,
          url: '/service-providers/create',
        },
      ],
    },
  }),
  secureRoute({
    path: 'service-providers/:id/edit',
    component: ServiceProviderEditComponent,

    data: {
      roles: ['mhs.scmmanager.user'],
      breadcrumbs: [
        {
          id: 0,
          label: 'podmioty',
          isCurrent: false,
          url: '/service-providers',
        },
        {
          id: 1,
          label: 'edycja',
          isCurrent: true,
          url: '/service-providers/:id/edit',
        },
      ],
    },
  }),
];
